import axios, { AxiosError } from 'axios';
import AppConsts from '../libs/AppConsts';
import { handleInactiveAccount } from './handleInactiveAccount';
import { handlePolicyAccessDenied } from './handlePolicyAccessDenied';

const req = axios.create({
  baseURL: AppConsts.host,
  headers: { 'Content-Type': 'application/json' },
});

// Request interceptor to add the token to every request
req.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

req.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    if (handleInactiveAccount(error)) {
      return Promise.reject(error);
    }
    handlePolicyAccessDenied(error);

    return Promise.reject(error);
  }
);

export default req;
